<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="introduction">
<section epub:type="division">
<p class="c12"><a id="page_xix"></a><strong class="calibre1">INTRODUCTION</strong></p>
</section>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0009.vue?12d5b0ef